/** CSGMesh3D parser - parses CSGMesh3D nodes from TSCN. */
import { parseGeometryInstance3D } from '../../geometryinstance3d/parser';
import { finishCsgParse } from '../sharedParser';
import { boolOr } from '../../../../parser/valueParsers';
import { holdsResource } from '../../../../godot/scene/resourceLiteral';
export function parseCSGMesh3D(heading, properties) {
    const geometry = parseGeometryInstance3D(heading, properties);
    const result = {
        ...geometry,
        flipFaces: boolOr(properties.flip_faces, false, 'CSGMesh3D flip_faces'),
    };
    if (holdsResource(properties.mesh))
        result.mesh = properties.mesh;
    // finishCsgParse copies the `material` path and `operation`.
    finishCsgParse(result, properties);
    return result;
}
//# sourceMappingURL=parser.js.map